import * as types from "../types/batch.types";

const initialState = {
  batchData: [],
  stackingMData: [],
  stackingOData: [],
  stackingRData: [],
  stackingSelectedZone: null,
};

const BatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_BATCH_DATA:
      return { ...state, batchData: action.payload };
    case types.SET_WALLET_STACKING_M_DATA:
      return { ...state, stackingMData: action.payload };
    case types.SET_WALLET_STACKING_O_DATA:
      return { ...state, stackingOData: action.payload };
    case types.SET_WALLET_STACKING_R_DATA:
      return { ...state, stackingRData: action.payload };
    case types.SET_STACKING_SELECTED_ZONE:
      return { ...state, stackingSelectedZone: action.payload };

    case types.RESET_BATCH_REDUCER:
      return {
        ...state,
        batchData: [],
        stackingMData: [],
        stackingOData: [],
        stackingRData: [],
        stackingSelectedZone: null,
      };
    default:
      return state;
  }
};
export default BatchReducer;
